import PropTypes from 'prop-types';
import InfiniteList from '@comp/InfiniteList/InfiniteList';
import { topologyLevels } from '@constants/index';
import FreeTopicFeed from './FreeTopicFeed';

const FreeTopicFeedList = ({
  topologyFeed,
  loadMore,
  goalTopology,
  topologyChildren,
  dataAnalytics
}) => {
  const renderFeedBlock = (feedData) => {
    let topologyData = null;
    if (topologyChildren) {
      topologyData = topologyChildren.find(
        (item) => item.uid === feedData.extraBlockinfo?.uid
      );
    }
    let href =
      '/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]';
    let seeAllLink = topologyData
      ? topologyData.relativeLink
      : `/goal/${goalTopology.slug}/${goalTopology.uid}/free-platform/${
          topologyData ? topologyData.slug : 'slug'
        }/${feedData.extraBlockinfo?.uid}`;
    if (topologyData?.level === topologyLevels.CONCEPT) {
      href =
        '/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]/[conceptUID]';
      seeAllLink = topologyData.relativeLink;
    }
    return (
      <FreeTopicFeed
        dataAnalytics={dataAnalytics}
        key={feedData.uid}
        courses={feedData.courses || feedData.data}
        title={feedData.label}
        blockInfo={feedData.extraBlockinfo}
        href={href}
        seeAllLink={seeAllLink}
      />
    );
  };

  return (
    <InfiniteList
      data={topologyFeed}
      loadMore={loadMore}
      _renderItem={renderFeedBlock}
    />
  );
};

FreeTopicFeedList.propTypes = {
  topologyFeed: PropTypes.objectOf(PropTypes.any).isRequired,
  loadMore: PropTypes.func.isRequired,
  goalTopology: PropTypes.objectOf(PropTypes.any).isRequired,
  topologyChildren: PropTypes.objectOf(PropTypes.any).isRequired,
  dataAnalytics: PropTypes.string.isRequired
};

export default FreeTopicFeedList;
